import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { noop } from 'ui-components/default-props/noop';

import EditTagRow from '../../edit-tag-row';
import ModalPortal from '../../modal-portal';
import style from './add-tags-modal.module.less';
import { useAddTags } from './hooks';
import { messages } from './messages';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../tracking/tracking-constants';

// todo when you add a new tag automatically scroll to bottom

export const AddTagsModal = ({ onClose = noop }) => {
  const { newTags, isSaving, onAddNewTag, onTagChanged, onRemoveTag, onSaveNewTags } = useAddTags({ onClose });
  const trackTagManagementWorkflow = useTrackWorkflow(Workflows.TAG_MANAGEMENT_FLOW);

  const onCancel = useCallback(() => {
    trackTagManagementWorkflow(WorkflowSteps.CANCEL);
    onClose();
  }, [onClose, trackTagManagementWorkflow]);

  return (
    <ModalPortal onCancel={onCancel} onClose={onClose}>
      <Modal className={style['add-tag-modal']}>
        <ModalHeader>
          <FormattedMessage {...messages.addTagTitle} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          {isSaving && <LoadingIndicator className={style['loading-indicator']} />}
          {!isSaving && (
            <div className={style['regular-content']}>
              <div className={style.tags}>
                {newTags.map((tag, index) => (
                  <EditTagRow
                    key={index}
                    className={style['tag-row']}
                    onChange={(newTag) => onTagChanged(newTag, index)}
                    onXClicked={() => onRemoveTag(index)}
                    tag={tag}
                  />
                ))}
              </div>
              <div className={style['add-new-tag-wrapper']}>
                <Button onClick={onAddNewTag} theme='link'>
                  <FormattedMessage {...messages.addNewTagButton} />
                </Button>
              </div>
            </div>
          )}
        </ModalBody>
        {!isSaving && (
          <ModalFooter className={style['modal-footer']}>
            <ModalFooterCancelButton />
            <Button onClick={() => onSaveNewTags(newTags)} theme='primary'>
              <FormattedMessage {...messages.submitNewTagsButton} values={{ tagsCount: newTags.length }} />
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </ModalPortal>
  );
};

AddTagsModal.propTypes = {
  onClose: PropTypes.func,
};
